export * from './marketing-main/marketing-main.component';